<div class="loading">
  <h6>در حال بارگزاری نام متن ساختگی</h6>
  <p>excel</p>
  <div class="range-input">
    <div class="progress">
      <div
        class="progress-bar w-50"
        role="progressbar"
        aria-valuenow="75"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
    <morva-icons icon="pause-upload"></morva-icons>
    <morva-icons icon="cancel-upload"></morva-icons>
  </div>
  <p>51 مکابایت - 50%</p>
</div>
